import { CustomersApi, CustomerResponse } from '@oncampusabroad/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialApiState, ApiCallBase, createApiConfiguration } from './apiConfiguration';

interface CustomerCall extends ApiCallBase {
  response: CustomerResponse;
}

interface State {
  customer: CustomerCall;
}

const initialState: State = {
  customer: initialApiState,
};

export const getCustomer = createAsyncThunk(
  'customers/getCustomer',
  async ({ customerId, token }: { customerId: string; token?: string }, { rejectWithValue }) => {
    try {
      const customersApi = new CustomersApi(createApiConfiguration(token));
      
      const response = await customersApi.getCustomer(customerId);
      return response.data;
    } catch (error: any) {
      console.error('Error getting customer:', error);
      return rejectWithValue({
        i18nMessage: error.response?.data?.i18nMessage ?? 'api.error.server_error',
        status: error.response?.status,
      });
    }
  }
);

const CustomersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    resetCustomer: (state) => {
      state.customer = {
        ...initialApiState,
        response: state.customer.response,
      };
    },
    resetCustomerResponse: (state) => {
      state.customer = {
        ...initialApiState,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomer.pending, (state) => {
      state.customer.loading = 'pending';
    });
    builder.addCase(getCustomer.fulfilled, (state, action) => {
      state.customer.loading = 'succeeded';
      state.customer.response = action.payload;
    });
    builder.addCase(getCustomer.rejected, (state, action) => {
      state.customer.loading = 'failed';
      state.customer.error = action.payload;
    });
  },
});

export const {
  resetCustomer,
  resetCustomerResponse,
} = CustomersSlice.actions;

export default CustomersSlice.reducer; 